import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    console.error('Uncaught error:', error, errorInfo);
  }
  render() {
    const {
      error
    } = this.state;
    const {
      ErrorComponent,
      children
    } = this.props;
    if (error) {
      return /*#__PURE__*/_jsx(ErrorComponent, {
        error: error
      });
    }
    return children;
  }
}
export default ErrorBoundary;